import useSponsorsEditForm from "./UseSponsorsEditForm";

import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SponsorsEditForm = ({ sponsorObj, submitButtonText = 'Save', secondaryButtonText = 'Cancel',
  onSubmitFormCallback, onSecondaryButtonClicked, onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isDirty,
    formState,
    errorState,
    handleSubmit,
    updateFormState
  } = useSponsorsEditForm(sponsorObj, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <ReadOnly
            label="Sponsor"
            name="sponsorId"
            value={sponsorObj.sponsor?.sponsorName} />
        </div>
        <div className="col-xs-12 col-sm-6">
          <ReadOnly
            label="Sponsor Type"
            name="sponsorTypeId"
            value={sponsorObj.sponsor?.sponsorType?.typeName} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <DatePicker
            label="Effective Date*"
            name="effectiveDate"
            value={formState.effectiveDate}
            error={errorState.effectiveDate}
            message={errorState.effectiveDate}
            countOfYears={150}
            startYearOffset={-149}
            onChange={(value) => { updateFormState('effectiveDate', value); }} />
        </div>
        <div className="col-xs-12 col-sm-6">
          <DatePicker
            label="Expiration Date*"
            name="expirationDate"
            value={formState.expirationDate}
            error={errorState.expirationDate}
            message={errorState.expirationDate}
            countOfYears={150}
            startYearOffset={-140}
            onChange={(value) => { updateFormState('expirationDate', value); }} />
        </div>
      </div>
      {errorState.errorOnSubmitAction &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
          </div>
        </div>
      }
      {errorState.formError &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.formError || ''}</p>
          </div>
        </div>
      }
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="submit" isDisabled={isDirty === false}>{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type='button' onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default SponsorsEditForm;